import { m8API } from 'services/production/m8';
import { PartnerVerificationService } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { DONE_TIMEOUT_DURATION } from 'utils/constants';
import { normalizeM8AccountInfo } from '../utils/normalizeM8AccountInfo';

export const verifyPartner: PartnerVerificationService = async (params) => {
  const {
    values: { codeChars },
    isClient,
  } = params;

  // Запрос отправляется без ожидания, чтобы он выполнялся параллельно
  // фиктивной задержке (нужно чтобы индикатор загрузки не мерцал из-за
  // быстрого выполнения запроса).
  // Promise.all не подходит, потому что в случае ошибки
  // фиктивная задержка будет прервана.

  const promoCode = codeChars.join('');

  const m8Request = m8API.auth.checkPromocode({
    promoCode,
    isPartner: true,
  });

  await asyncTimeout(DONE_TIMEOUT_DURATION);

  await m8Request;

  if (isClient) {
    const m8AccountInfo = await m8API.user.wantToBePrePartner();

    return normalizeM8AccountInfo(m8AccountInfo).toUserAccountInfo();
  }
};
